import { VinVehicleInfo } from 'api/canpark/scanning/extractVin';

/**
 * Formats decoded vehicle data from VIN into a readable string.
 * Filters out null values and joins remaining fields with spaces.
 *
 * @param vehicleInfo - The decoded vehicle information from VIN
 * @returns Formatted string like "Honda Accord 2020 Sedan" or empty string if all fields are null
 *
 * @example
 * formatVehicleInfoFromVin({ make: "Honda", model: "Accord", modelYear: "2020", bodyType: "Sedan" })
 * // Returns: "Honda Accord 2020 Sedan"
 *
 * @example
 * formatVehicleInfoFromVin({ make: "Honda", model: null, modelYear: "2020", bodyType: null })
 * // Returns: "Honda 2020"
 */
export const formatVehicleInfoFromVin = (
	vehicleInfo: VinVehicleInfo | null,
): string => {
	if (!vehicleInfo) {
		return '';
	}

	const parts: string[] = [];

	if (vehicleInfo.make) {
		parts.push(vehicleInfo.make);
	}
	if (vehicleInfo.model) {
		parts.push(vehicleInfo.model);
	}
	if (vehicleInfo.modelYear) {
		parts.push(vehicleInfo.modelYear);
	}
	if (vehicleInfo.bodyType) {
		parts.push(vehicleInfo.bodyType);
	}

	return parts.join(' ');
};
